import { Injectable } from '@angular/core';
import { CalendarView } from 'angular-calendar';
import { Subject } from 'rxjs';
import ICalendar from '../../../app/_interfaces/ICalendar';

@Injectable({
  providedIn: 'root',
})
export class CalendarAppointmentsService {
  calendarView$: Subject<CalendarView>;
  calendars$: Subject<ICalendar[]>;
  patientAppointments$: Subject<void>;

  constructor() {
    this.calendarView$ = new Subject<CalendarView>();
    this.calendars$ = new Subject<ICalendar[]>();
    this.patientAppointments$ = new Subject<void>();
  }

  setCalendarView$(calendarView: CalendarView) {
    this.calendarView$.next(calendarView);
  }

  listenPatientAppointments$() {
    return this.patientAppointments$.asObservable();
  }

  emitPatientAppointments$() {
    this.patientAppointments$.next();
  }

  getCalendarView$() {
    return this.calendarView$.asObservable();
  }

  setCalendar$(calendar: ICalendar[]) {
    this.calendars$.next(calendar);
  }

  getCalendar$() {
    return this.calendars$.asObservable();
  }
}
